import { AppError } from "../../../shared/utils/error-handler";
import type { CompanyBankTransferRepository } from "../../repositories/company/company-bank-transfer-repository";
import type {
  BankTransferEntity,
  CreateBankTransferCommand,
  UpdateBankTransferCommand,
} from "../../types/company-bank-transfer";

export class CompanyBankTransferUsecase {
  constructor(
    private companyBankTransferRepository: CompanyBankTransferRepository,
  ) {}

  async getBankTransfer(companyId: number): Promise<BankTransferEntity[]> {
    try {
      return await this.companyBankTransferRepository.getBankTransfer(
        companyId,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "회사 무통장 정보를 불러오지 못했습니다.",
        "BANK_TRANSFER_GET_FAILED",
        error,
      );
    }
  }

  async createBankTransfer(
    companyId: number,
    command: CreateBankTransferCommand,
  ): Promise<BankTransferEntity> {
    try {
      return await this.companyBankTransferRepository.createBankTransfer(
        companyId,
        command,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "회사 무통장 정보를 생성하지 못했습니다.",
        "BANK_TRANSFER_GET_FAILED",
        error,
      );
    }
  }

  async updateBankTransfer(
    companyId: number,
    bankTransferId: number,
    command: UpdateBankTransferCommand,
  ): Promise<BankTransferEntity> {
    try {
      return await this.companyBankTransferRepository.updateBankTransfer(
        companyId,
        bankTransferId,
        command,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "회사 무통장 정보를 생성하지 못했습니다.",
        "BANK_TRANSFER_GET_FAILED",
        error,
      );
    }
  }

  async deleteBankTransfer(
    companyId: number,
    banTransferId: number,
  ): Promise<boolean> {
    try {
      return await this.companyBankTransferRepository.deleteBankTransfer(
        companyId,
        banTransferId,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "회사 무통장 정보를 생성하지 못했습니다.",
        "BANK_TRANSFER_GET_FAILED",
        error,
      );
    }
  }
}
